import React from 'react';

const DashboardSidebar = ({ activeView, setActiveView, isDarkMode }) => {
  const menuItems = [
    { id: 'checker', name: 'Checker', icon: (
      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    )},
    { id: 'generator', name: 'Generador', icon: (
      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
    )},
    { id: 'settings', name: 'Configuración', icon: (
      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    )}
  ];

  return (
    <div className={`h-full ${isDarkMode ? 'bg-gray-900/80 border-gray-700' : 'bg-white/90 border-gray-200'} border-r w-64 flex-shrink-0 shadow-lg backdrop-blur-md z-10 relative`}>
      <div className="h-full flex flex-col">
        <nav className="mt-5 flex-1 px-2 space-y-1">
          {menuItems.map((item, index) => (
            <button
              key={item.id}
              onClick={() => setActiveView(item.id)}
              className={`${
                activeView === item.id
                  ? 'bg-indigo-600 text-white shadow-md'
                  : `${isDarkMode ? 'text-gray-300 hover:bg-gray-700 hover:text-white' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`
              } group flex items-center px-4 py-3 text-base font-medium rounded-lg w-full transition-all duration-200 transform hover:scale-[1.02] animate-fade-in`}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className={`${
                activeView === item.id ? 'text-white' : `${isDarkMode ? 'text-gray-400 group-hover:text-gray-300' : 'text-gray-400 group-hover:text-gray-500'}`
              } mr-3 transition-colors`}>
                {item.icon}
              </div>
              {item.name}
            </button>
          ))}
        </nav>
        <div className={`p-4 ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} border-t`}>
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="h-10 w-10 rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-lg">
                A
              </div>
            </div>
            <div className="ml-3">
              <p className={`text-sm font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>Admin</p>
              <p className={`text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Plan Premium</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSidebar;